/* eslint-disable import/order */
import { makeStyles } from '@mui/styles';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import './styles.css';

import { useSelector } from 'react-redux';

import { AgendaView, DayView, MonthView, WeekView, WorkWeekView } from './CalendarViews';
import Toolbar from './Toolbar';
import Link from '../../../components/Link';

const localizer = momentLocalizer(moment);

const useStyles = makeStyles({
  link: {
    color: '#297dfd',
  },
  calendar: {
    '& button': {
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
});

function Calendar({ events, onShowFilter, onRefresh, renderEventTitle, ...props }) {
  const classes = useStyles();
  const culture = useSelector((state) => state.auth.culture);
  const [lang, setLang] = useState(null);
  const [locale, setLocale] = useState(null);

  useEffect(() => {
    const [lang] = culture.split('-');
    setLang(lang);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    try {
      lang && setLocale(require(`moment/locale/${lang}`));
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('locale not found');
    }
  }, [lang]);

  function AgendaDate({ label }) {
    return <span ui-ta="Event Date">{label}</span>;
  }

  function AgendaEvent({ event }) {
    return (
      <span ui-ta={`Event ${event.selector}`}>
        <Link to={event.link} className={classes.link}>
          {renderEventTitle ? renderEventTitle(event) : <span>{event.title}</span>}
        </Link>
        <p>{event.desc}</p>
      </span>
    );
  }

  function CalendarEvent({ event }) {
    return (
      <span ui-ta={`Event ${event.selector}`}>
        {renderEventTitle ? renderEventTitle(event) : <span>{event.title}</span>}
      </span>
    );
  }

  return (
    <BigCalendar
      {...props}
      className={classes.calendar}
      localizer={localizer}
      events={events}
      culture={locale && lang}
      views={{
        month: MonthView,
        week: WeekView,
        work_week: WorkWeekView,
        day: DayView,
        agenda: AgendaView,
      }}
      components={{
        event: CalendarEvent,
        toolbar: (props) => (
          <Toolbar {...props} onShowFilter={onShowFilter} onRefresh={onRefresh} />
        ),
        agenda: {
          date: AgendaDate,
          event: AgendaEvent,
        },
      }}
    />
  );
}

export default Calendar;
